import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=872340e0&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/page/login.css?vue&type=style&index=0&id=872340e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872340e0",
  null
  
)

export default component.exports